import { db, UIEntities } from "../db";
import { auditEntity } from "../helpers";

export const uiEntitiesRepository = {
  get: (uniqueId: string) => {
    return db.uiEntities.get(uniqueId);
  },
  put: (uiEntity: UIEntities) => {
    auditEntity(uiEntity);
    return db.uiEntities.put(uiEntity);
  },
  bulkPut: (uiEntities: UIEntities[]) => {
    for (let i = 0; i < uiEntities.length; i++) {
      auditEntity(uiEntities[i]);
    }
    return db.uiEntities.bulkPut(uiEntities);
  },
};
